import { Component, OnInit, OnDestroy, PLATFORM_ID, Inject, ElementRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../_services/langhfre.service';
import { LoadScriptService } from 'src/app/_services/load-script.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {
  formSection: boolean = true;
  thankSection: boolean = false;
  country: string;
  isSubmitting: boolean = false;
  showLanguages: boolean = false;

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private elementRef: ElementRef,
    public loadScript: LoadScriptService
  ) {
  }
  
  keyFeatures = [
    { title: '语法检查', route: ['/features/grammar-checker'], icon: '/assets/images/menu-icons/grammar-checker.svg', alt: 'grammar checker' },
    { title: '智能改写', route: ['/features/paraphraser'], icon: '/assets/images/menu-icons/pharaphraser.svg', alt: 'paraphraser' },    
    { title: '一致性检查', route: ['/features/consistency-check'], icon: '/assets/images/menu-icons/consistency.svg', alt: 'consistency checker' },
    { title: '包容性语言检测', route: ['/features/inclusive-language-check'], icon: '/assets/images/menu-icons/inclusive-language.svg', alt: 'bias free writing' },
    { title: '校对 MS Word 文件', route: ['/features/proofread-file'], icon: '/assets/images/menu-icons/proofread.svg', alt: 'proofreading file' },
    { title: 'LaTeX文档校对', route: ['/features/latex-grammar-checker'], icon: '/assets/images/menu-icons/spell-check.svg', alt: 'latex Proofreader' },
    { title: '个人词典', route: ['/features/personal-dictionary'], icon: '/assets/images/menu-icons/personal-dictionary.svg', alt: 'dictionary' },
    { title: '法律文书写作', route: ['/features/legal-writing'], icon: '/assets/images/menu-icons/legal-writing.svg', alt: 'writing tool for lawyers' },
    { title: '抄袭检测', route: ['/features/plagiarism-check'], icon: '/assets/images/menu-icons/plagiarism.svg', alt: 'plagiarism-check' },
    { title: '技术核查', route: ['/features/technical-checks'], icon: '/assets/images/menu-icons/publications.svg', alt: 'Manuscript Checker' },
    { title: '期刊查找', route: ['/features/journal-finder'], icon: '/assets/images/menu-icons/journal-finder.svg', alt: 'find right journal' },
    { title: '引文检查', route: ['/features/citation-checker'], icon: '/assets/images/menu-icons/citation-checker.svg', alt: 'check for correct references' }
  ];

  icons = [
    { src: '/assets/images/list-icons/google-gmail.svg', width: 27, height: 21, alt: 'gmail' },
    { src: '/assets/images/list-icons/chrome.svg', width: 28, height: 27, alt: 'chrome' },
    { src: '/assets/images/list-icons/linkedin.svg', width: 27, height: 27, alt: 'linkedin' },
    { src: '/assets/images/list-icons/bing.svg', width: 18, height: 28, alt: 'bing' },
    { src: '/assets/images/list-icons/apple.svg', width: 32, height: 31, alt: 'apple' },
    { src: '/assets/images/list-icons/facebook.svg', width: 29, height: 29, alt: 'facebook' },
    { src: '/assets/images/list-icons/office.svg', width: 21, height: 25, alt: 'office' },
    { src: '/assets/images/list-icons/googledocs.svg', width: 27, height: 27, alt: 'googledocs' },
    { src: '/assets/images/list-icons/medium.svg', width: 39, height: 6, alt: 'medium' },
    { src: '/assets/images/list-icons/powerpoint.svg', width: 32, height: 32, alt: 'powerpoint' },
    { src: '/assets/images/list-icons/asana.svg', width: 39, height: 8, alt: 'asana' },
    { src: '/assets/images/list-icons/word.svg', width: 29, height: 30, alt: 'word' },
    { src: '/assets/images/list-icons/notion.svg', width: 39, height: 14, alt: 'notion' },
    { src: '/assets/images/list-icons/firefox.svg', width: 27, height: 28, alt: 'firefox' },
    { src: '/assets/images/list-icons/twitter.svg', width: 27, height: 28, alt: 'twitter' },
    { src: '/assets/images/list-icons/outlook.svg', width: 30, height: 30, alt: 'outlook' },
    { src: '/assets/images/list-icons/quora.svg', width: 33, height: 9, alt: 'quora' },
    { src: '/assets/images/list-icons/bi_substack.svg', width: 20, height: 20, alt: 'bi_substack' }
  ];

  ngOnInit() {
    this.titleService.setTitle('Trinka-学术和技术英语写作语法检查工具');
    this.metaTagService.updateTag({ name: 'description', content: '用于学术和技术写作的英语语法检查工具，高级语法校正，学术写作助手，技术写作助手，高级语法检查，自动化语法检查工具，自动化语法校正，学术写作人工智能工具。' });
    this.metaTagService.updateTag({ name: 'keywords', content: '英语语法检查' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka-学术和技术英语写作语法检查工具' });
    this.metaTagService.updateTag({ property: 'og:description', content: '用于学术和技术写作的英语语法检查工具，高级语法校正，学术写作助手，技术写作助手，高级语法检查，自动化语法检查工具，自动化语法校正，学术写作人工智能工具。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://trinka.enago.cn' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ name: 'language', content: 'zh-cn' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://trinka.enago.cn' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/' });
  }
  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('main_header').classList.remove('homepageHeader');
    }
  }

  ngAfterViewChecked(): void {
    this.setSliderPosition();
  }

  onTabClick(event: any): void {
    this.setSliderPosition();
  }

  scrollToElementWithOffset(id: string, offset: number = 0) {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: yOffset, behavior: 'smooth' });
    }
  }

  private setSliderPosition(): void {
    const tabs = this.elementRef.nativeElement.querySelectorAll('#tile-1 .nav-pills a');
    const activeTab = this.elementRef.nativeElement.querySelector('#tile-1 .nav-pills .active');

    if (activeTab) {
      const tabsContainer = this.elementRef.nativeElement.querySelector('#tile-1 .nav-pills');
      const position = activeTab.offsetLeft - tabsContainer.offsetLeft;
      const width = activeTab.offsetWidth;

      const slider = this.elementRef.nativeElement.querySelector('#tile-1 .slider');
      slider.style.left = position + 'px';
      slider.style.width = width + 'px';
    }
  }

}
